import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { ROUTES } from "@/utils/navigation";

interface IProps {
  totalItems: number;
  totalAmount: number;
  closePopUp: () => void;
}

const PopUpFooter: React.FC<IProps> = ({
  totalItems,
  totalAmount,
  closePopUp,
}) => {
    const newTotalAmount = totalAmount % 1 === 0 ? totalAmount : totalAmount.toFixed(2);

    return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        my={2}
      >
        <Typography
          variant="subtitle1"
          component="p"
          color="text.primary"
          fontWeight={600}
          fontSize={{ xs: "1rem", md: "1rem" }}
        >
          Subtotal ({totalItems} items):
        </Typography>
        <Typography
          variant="subtitle1"
          component="p"
          fontWeight={700}
          fontSize={{ xs: "1rem", md: "1rem" }}
          color="text.accent"
        >
          ${newTotalAmount}
        </Typography>
      </Box>

      <Button
        component={Link}
        to={`${ROUTES.cart}`}
        onClick={closePopUp}
        variant="contained"
        fullWidth
      >
        Go to cart
      </Button>
    </>
  );
};

export default PopUpFooter;
